// @flow
import React from 'react';

const LanguageContext = React.createContext({
  localeContext: {
    changeLanguage: () => {}
  }
});

export default LanguageContext;
